// @ts-nocheck

import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { ZIndices } from '../../../styled-components/dark/common';
import { type Point2D } from '../../../types/point';
import { ODDS_TRAVEL_ANIMATION_DURATION } from '../constants/oddsTravel';
import OddsTravelAnimationContainer from '../containers/OddsTravelAnimationContainer';

const Wrapper = styled.div`
  position: fixed;
  z-index: ${ZIndices.oddsTravelAnimation};
  top: 0;
  left: 0;
`;

type ActiveAnimation = {
  oddId: number;
  ts: number;
  pid?: TimeoutID;
  translation?: {
    from: Point2D;
    to: Point2D;
  };
};

type OddsTravelAnimationTriggererProps = {
  className?: string;
  animations: Array<{ oddId: number; ts: number; sourceElementUuid: string }>;
  popAnimation: (params: { oddId: number; ts: number }) => void;
};

const OddsTravelAnimationTriggerer = ({
  className = '',
  animations,
  popAnimation,
}: OddsTravelAnimationTriggererProps) => {
  const [activeAnimations, setActiveAnimations] = useState<Array<ActiveAnimation>>([]);
  const activeAnimationsRef = useRef<Array<ActiveAnimation> | null>();
  const popAnimationRef = useRef();

  useEffect(() => {
    activeAnimationsRef.current = activeAnimations;
  }, [activeAnimations]);

  useEffect(() => {
    popAnimationRef.current = popAnimation;
  }, [popAnimation]);

  useEffect(() => {
    setActiveAnimations((prev) => {
      const animationsToKeep = prev.filter((a) => !!animations.find((b) => b.oddId === a.oddId && b.ts === a.ts));
      const animationsToAdd = animations
        .filter((a) => !prev.find((b) => b.oddId === a.oddId && b.ts === a.ts))
        .map((enhancedAnimation) => {
          const { oddId, sourceElementUuid, ts } = enhancedAnimation;
          const next: ActiveAnimation = { oddId, ts };

          const launchNode = document.getElementById(`odd-button-${oddId}-${sourceElementUuid}`);
          const basketNode = document.getElementById(`basket-floating-button-center`);

          if (launchNode && basketNode) {
            const launchNodeBC = launchNode.getBoundingClientRect();
            const basketNodeBC = basketNode.getBoundingClientRect();

            if (launchNodeBC && basketNodeBC) {
              const { left: fromX, top: fromY } = launchNodeBC;
              const { left: toX, top: toY } = basketNodeBC;

              if (
                typeof fromX === 'number' &&
                typeof fromY === 'number' &&
                typeof toX === 'number' &&
                typeof toY === 'number'
              ) {
                const from = { x: fromX, y: fromY };
                const to = { x: toX, y: toY };

                const nextPosition = { from, to };

                next.translation = nextPosition;
              }
            }
          }

          next.pid = setTimeout(() => {
            popAnimationRef.current?.({ oddId, ts });
          }, ODDS_TRAVEL_ANIMATION_DURATION);

          return next;
        });

      return [...animationsToKeep, ...animationsToAdd];
    });
  }, [animations]);

  useEffect(() => {
    return () => {
      const activeAnims = activeAnimationsRef.current;

      if (Array.isArray(activeAnims)) {
        for (const animation of activeAnims) {
          const { pid } = animation ?? {};

          if (pid) {
            clearTimeout(pid);
          }
        }
      }
    };
  }, []);

  return (
    <Wrapper className={className}>
      {activeAnimations.map(({ oddId, ts, translation }) => (
        <OddsTravelAnimationContainer
          key={`${oddId}-${ts}`}
          oddId={oddId}
          from={translation?.from}
          to={translation?.to}
        />
      ))}
    </Wrapper>
  );
};

export default OddsTravelAnimationTriggerer;
